import { isAxiosError } from 'axios';
import { axiosFuex } from '@httpClients';
import { ListPages } from '@enums/enums';
import { B2cAuthErrorTypes } from '@enums/B2cAuthErrorTypesEnum';
import { RecipientsReportTypeType } from '../types/responses/recipients-reports';
import { msalInstance } from '../msalconfig';

export const fetchRecipientsdReportData = async (
  cursor: PaginationRecipientsCursorType | DownloadCursorType,
  pageSize?: number
): Promise<RecipientsReportTypeType | DownloadResponse | undefined> => {
  let data;

  try {
    const authToken = sessionStorage.getItem('authToken');
    const authHeader = `Bearer ${authToken}`;

    const searchParams = new URLSearchParams();
    if (pageSize) {
      searchParams.append('pageSize', pageSize.toString());
    }

    const url = `/recipients/list?${searchParams.toString()}`;
    const stringifyBody = JSON.stringify(cursor);

    const res = await axiosFuex.post(url, stringifyBody, {
      headers: {
        Authorization: authHeader,
      },
    });

    if (res?.data.data) {
      const responseData = res.data.data;
      data = {
        data: responseData?.data || [],
        totalOnPage: responseData?.totalOnPage || 0,
        totalResults: responseData?.totalResults || 0,
        lastEvaluatedKey: responseData?.lastEvaluatedKey || null,
      };
    }
    return data;
  } catch (error) {
    if (
      isAxiosError(error) &&
      (error.response?.status === 401 || error.response?.status === 403)
    ) {
      sessionStorage.clear();
      try {
        await msalInstance.logoutRedirect({
          postLogoutRedirectUri: window.location.origin + ListPages.Login,
        });
      } catch (logoutError) {
        console.error('Error during logout:', logoutError);
        window.location.href = `${ListPages.Login}?error=${B2cAuthErrorTypes.MissingToken}`;
      }
      throw new Error('Unauthorized access, redirecting to login.');
    } else {
      throw error;
    }
  }
};
